module.exports = __webpack_public_path__ + "static/cavan-logo-d068d5408ddeb0d2f951e48c0b6fe807.png";